import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {AuthService} from '../../auth/auth.service';
import {environment} from '../../../environments/environment';
import {AuthenticationService} from '../../authentication.service';


@Injectable({
    providedIn: 'root'
})
export class HttpTokenInterceptorService {

    constructor(private auth: AuthService, private router: Router, private token: AuthenticationService) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.url.includes(environment.searchUrl)) {
            request = request.clone({
                setHeaders: {
                    'Authorization': `Bearer ${this.auth.getValue('search_token', false)}`,
                    'AppId': environment.AppID,
                    'version': '1',
                    'Content-Type': 'application/json'
                }
            });
        } else if (request.url.includes(environment.ipobaseUrl)) {
            request = request.clone({
                setHeaders: {
                    'Authorization': `Bearer ${this.auth.getValue('ipo_token', false)}`,
                }
            });
        } else {
            request = request.clone({
                setHeaders: {
                    'Authorization': `Bearer ` + localStorage.getItem('auth_token'),
                    'Content-Type': 'application/json'
                }
            });
        }
        return next.handle(request).pipe(tap(() => {
            },
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status !== 401) {
                        return;
                    }
                    /** If kambala access token will expire then will immediately recall the access token
                     * to refresh the token on user end */
                    if (request.url.includes(environment.searchUrl)) {
                        this.token.generateToken(1);
                    } else {
                        /** Else if research panel token will expire than will logout the user */
                        localStorage.clear();
                        this.router.navigate(['login']);
                    }
                }
            }));
    }

}
